export const ssoParamValue = {
  responseTypeCode: 'code',
  scopeEmail: 'email',
  scopeProfile: 'profile',
  scopeProfileEdit: 'profile.edit',
  scopeOfflineAccess: 'offline_access',
  grantTypeAuthorizationCode: 'authorization_code',
  grantTypeRefreshToken: 'refresh_token',
  openid: 'openid',
  promptNone: 'none',
};
